// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export function debinOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  const installments_plan_token = userInputValues['installmentsPlanToken'] ? {
    installments_plan_token: userInputValues['installmentsPlanToken'],
  } : {};

  return {
    country: 'ar',
    payment_type: 'banktransfer',
    payment_type_code: 'debin',
    document: userInputValues['argentineDocument'],
    bank_details: {
      bank_code: '',
      account_number: userInputValues['argentineCbu'],
    },
    ...installments_plan_token,
  };
}
